module.exports = __webpack_public_path__ + "static/media/068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M.b0373242.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M
// module id = 691
// module chunks = 0